import { Action, State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';

const exportFunc = (state: State, action: Action) => {
  return {
    [ACTION_TYPES.SET_IS_READONLY]: () => ({
      ...state,
      permission: {
        isReadonly: true,
      },
    }),

    [ACTION_TYPES.SET_IS_NOT_READONLY]: () => ({
      ...state,
      permission: {
        isReadonly: false,
      },
    }),
  };
};

export default exportFunc;
